export const privacy = {
  backToHome: "Terug naar home",
  title: "Privacyverklaring",
  lastUpdated: "Laatst bijgewerkt:",
  sections: {
    introduction: {
      title: "1. Inleiding",
      content: "NovaVenture Group BV (hierna: 'NovaVenture', 'wij' of 'ons') respecteert uw privacy en is toegewijd aan het beschermen van persoonsgegevens conform de Algemene Verordening Gegevensbescherming (AVG/GDPR) en de Belgische wetgeving. Deze privacyverklaring legt uit hoe wij bedrijfsgegevens verzamelen, gebruiken en beschermen in het kader van onze B2B-activiteiten."
    },
    company: {
      title: "2. Verantwoordelijke voor de Gegevensverwerking",
      content: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, België",
      vat: "BTW-nummer: BE1006303437",
      enterprise: "Ondernemingsnummer: 1006303437",
      email: "E-mail: David@novaventure.be",
      phone: "Telefoon: +32 488 13 96 64"
    },
    dataCollection: {
      title: "3. Welke Gegevens Verwerken Wij?",
      intro: "NovaVenture verwerkt uitsluitend zakelijke bedrijfsgegevens die publiek toegankelijk zijn. Wij verwerken GEEN persoonlijke gegevens van natuurlijke personen, zoals namen van individuen, persoonlijke e-mailadressen of andere gevoelige persoonsgegevens.",
      subtitle: "De volgende bedrijfsgegevens worden verwerkt:",
      items: {
        company: "Bedrijfsnaam (officiële handelsnaam)",
        phone: "Vast telefoonnummer van de onderneming",
        address: "Volledig bedrijfsadres (straat, nummer, postcode, gemeente)",
        vat: "BTW-nummer van de onderneming"
      },
      note: "Deze gegevens betreffen uitsluitend rechtspersonen (ondernemingen) en geen natuurlijke personen in privécontext."
    },
    dataSource: {
      title: "4. Herkomst van de Gegevens",
      content: "Alle bedrijfsgegevens worden verzameld uit publiek toegankelijke online bronnen waar ondernemingen hun informatie zelf openbaar hebben gepubliceerd, zoals:",
      sources: [
        "Officiële bedrijfsregisters en handelsregisters",
        "Openbare websites van ondernemingen",
        "Publieke bedrijfsgidsen en directories",
        "Andere legale, publiek toegankelijke bronnen"
      ],
      note: "Wij kopen geen privé-databanken aan en verwerken geen gegevens uit niet-openbare bronnen."
    },
    dataUsage: {
      title: "5. Doeleinden van de Gegevensverwerking",
      intro: "Wij verwerken bedrijfsgegevens voor de volgende doeleinden:",
      items: [
        "B2B prospectie en zakelijke leadgeneratie",
        "Commerciële verkoop van bedrijfsgegevens aan zakelijke klanten",
        "Verstrekking van zakelijke marktinformatie",
        "Ondersteuning van legitieme zakelijke activiteiten van onze klanten"
      ]
    },
    legalBasis: {
      title: "6. Rechtsgrondslag",
      intro: "De verwerking van bedrijfsgegevens is gebaseerd op artikel 6, lid 1, onder f) AVG: gerechtvaardigd belang.",
      content: "NovaVenture heeft een gerechtvaardigd belang bij het verzamelen en verstrekken van publiek beschikbare bedrijfsgegevens ten behoeve van legitieme B2B-activiteiten. Wij hebben een zorgvuldige belangenafweging gemaakt:",
      balancing: {
        title: "Belangenafweging:",
        business: "Zakelijk belang: Het faciliteren van efficiënte B2B-communicatie en marktwerking",
        privacy: "Privacy-impact: Minimaal, aangezien uitsluitend publiek beschikbare bedrijfsgegevens van rechtspersonen worden verwerkt",
        noPersonal: "Geen verwerking van persoonlijke gegevens van natuurlijke personen in privécontext",
        objection: "Ondernemingen hebben te allen tijde het recht om bezwaar te maken tegen opname in onze databank"
      }
    },
    retention: {
      title: "7. Bewaartermijn",
      content: "Bedrijfsgegevens worden niet langer bewaard dan noodzakelijk voor de doeleinden waarvoor zij zijn verzameld. Wij voeren periodieke controles uit om de actualiteit en relevantie van de gegevens te waarborgen. Verouderde of onjuiste gegevens worden verwijderd of bijgewerkt."
    },
    dataSharing: {
      title: "8. Verstrekking aan Derden",
      intro: "Bedrijfsgegevens worden verstrekt aan:",
      items: [
        "Zakelijke klanten die de gegevens gebruiken voor legitieme B2B-prospectie",
        "Dienstverleners die ons ondersteunen (bijv. hosting, IT-beveiliging), onder strikte vertrouwelijkheidsverplichtingen"
      ],
      euOnly: "Wij verwerken geen gegevens buiten de Europese Unie. Alle gegevensverwerking vindt plaats binnen de EU/EER."
    },
    yourRights: {
      title: "9. Uw Rechten als Betrokkene",
      intro: "Indien uw onderneming is opgenomen in onze databank, heeft u de volgende rechten:",
      items: {
        access: "Recht op inzage: U kunt opvragen welke bedrijfsgegevens wij over uw onderneming verwerken",
        rectification: "Recht op correctie: U kunt verzoeken om correctie van onjuiste of verouderde gegevens",
        erasure: "Recht op verwijdering: U kunt verzoeken om verwijdering van de gegevens van uw onderneming",
        restriction: "Recht op beperking: U kunt verzoeken om beperking van de verwerking",
        objection: "Recht van bezwaar: U kunt te allen tijde bezwaar maken tegen de verwerking van bedrijfsgegevens van uw onderneming"
      },
      objectionNote: {
        title: "Expliciete bezwaarmogelijkheid:",
        content: "Ondernemingen kunnen te allen tijde bezwaar maken tegen opname in onze databank. Na ontvangst van uw bezwaar zullen wij uw bedrijfsgegevens verwijderen uit onze systemen, tenzij wij aantoonbare dwingende gerechtvaardigde gronden voor de verwerking hebben die zwaarder wegen dan uw belangen."
      },
      howTo: {
        title: "Hoe kunt u uw rechten uitoefenen?",
        content: "U kunt uw rechten uitoefenen door een verzoek te sturen naar:",
        email: "E-mail: David@novaventure.be",
        response: "Wij zullen uw verzoek binnen 30 dagen behandelen en u informeren over de genomen maatregelen."
      }
    },
    dataSecurity: {
      title: "10. Beveiliging van Gegevens",
      content: "NovaVenture neemt passende technische en organisatorische maatregelen om bedrijfsgegevens te beschermen tegen ongeautoriseerde toegang, verlies, misbruik, wijziging of openbaarmaking. Deze maatregelen omvatten onder meer:",
      measures: [
        "Beveiligde opslag en encryptie van gegevens",
        "Toegangscontrole en authenticatie",
        "Regelmatige beveiligingsupdates en monitoring",
        "Vertrouwelijkheidsverplichtingen voor medewerkers en verwerkers"
      ]
    },
    complaint: {
      title: "11. Klachtrecht",
      content: "Indien u van mening bent dat wij uw gegevens niet correct verwerken, heeft u het recht om een klacht in te dienen bij de Belgische toezichthoudende autoriteit:",
      authority: "Gegevensbeschermingsautoriteit (GBA)",
      addressLine1: "Drukpersstraat 35, 1000 Brussel, België",
      phone: "Telefoon: +32 2 274 48 00",
      email: "E-mail: contact@apd-gba.be",
      website: "Website: www.gegevensbeschermingsautoriteit.be"
    },
    changes: {
      title: "12. Wijzigingen in Deze Privacyverklaring",
      content: "NovaVenture behoudt zich het recht voor om deze privacyverklaring te wijzigen. Wijzigingen worden gepubliceerd op deze pagina met een bijgewerkte datum. Wij raden u aan deze verklaring regelmatig te raadplegen."
    },
    contact: {
      title: "13. Contact",
      intro: "Voor vragen over deze privacyverklaring of het uitoefenen van uw rechten kunt u contact met ons opnemen:",
      company: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, België",
      phone: "Telefoon:",
      email: "E-mail:",
      vat: "BTW: BE1006303437"
    }
  }
};